import React, { useEffect } from 'react';
import * as Yup from 'yup';

interface IProps {
  children: React.ReactNode;
}

const ValidationDictionaryProvider: React.FC<IProps> = ({ children }) => {
  useEffect(() => {
    Yup.setLocale({
      mixed: {
        required: 'Required',
      },
      string: {
        email: 'Incorrect email format',
      },
    });
  }, []);

  return <>{children}</>;
};

export default ValidationDictionaryProvider;
